<template>
    <div class='container'>
        <div v-if="number != 0" class="cart">
            <div class="cart_list">
                <div class="title">我的購物車</div>
                <hr>
                <section class="cart_detail_area">
                    <!-- 头部 -->
                    <header class="item_header" style="">
                        <div class="th_product">品名</div>
                        <div class="th_specification css_th">規格</div>
                        <div class="th_quantity css_th">數量</div>
                        <div class="th_price css_th">單價</div>
                        <div class="th_subtotal css_th">小計</div>
                        <div class="th_del css_th">刪除</div>
                    </header>
                    <!-- 商品列表 -->
                    <div class="item_list" v-for="item, index in cart_list_item">
                        <div class="item_productinfo">
                            <!-- 名字 -->
                            <div class="td_product">
                                <div class="item_thumbs">
                                    <img :src="item.display_img_small" width="50" height="50" :alt="item.form_name">
                                </div>
                                <div class="item_info">
                                    <div class="purchase media clearfix">
                                        <div class="purchase_inner media-body">
                                            <a href="javascript:;" class="item_name"><span class="text_overflow">{{
            item.form_name }}</span></a>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <!-- 规格 -->
                            <div class="td_specification">

                                <div v-if="item.sub.length !== 0">
                                    <div v-for="items in item.sub" style="font-size: 12px; color: #000;">
                                        <span v-if="items.sub_type == 'SFREE'" style="color: #dc3545;">贈品-{{
            items.form_name }}*{{ items.num }}</span>
                                        <span v-else>{{ items.form_name }}*{{ items.num }}</span>
                                    </div>
                                </div>
                                <div v-else-if="true">
                                    單一規格
                                </div>
                            </div>
                            <!-- 数量 -->
                            <div class="td_quantity">
                                <!-- <select class="form_select form_control">
                                    <option value="1" selected="">1</option>
                                    <option value="2">2</option>
                                    <option value="3">3</option>
                                    <option value="4">4</option>
                                    <option value="5">5</option>
                                    <option value="6">6</option>
                                    <option value="7">7</option>
                                </select> -->
                                <div class="selectquantity d-flex justify-content-between align-items-center">
                                    <div class="form_label pb-0" for=""></div>
                                    <div class="selectquantity_select">
                                        <div class=" number d-flex   justify-content-between ">
                                            <button type="button" class="btn iconfont"
                                                @click="reduce(item, index)">&#xeaf5;
                                            </button>
                                            <input type="text" name="quantity" @change="changebalue(item, index)"
                                                v-model="item.num" class="border-0 text-center w-100   p-0" data-max="1"
                                                data-min="1" oninput="value=value.replace(/\D/g,'')">
                                            <button type="button" class="btn iconfont"
                                                @click="add(item, index)">&#xeaf3;
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 单价 -->
                            <div class="th_price css_th">
                                <div class="item_price">${{ item.price }}</div>
                            </div>
                            <!-- 小计 -->
                            <div class="td_subtotal ">
                                <div class="item_subtotal css_th" data-subtotal="小計："><b>${{ item.total }}</b></div>
                                <div class="item_subtotal_node" data-subtotal="小計：">小計：<b>${{ item.total }}</b></div>
                            </div>
                            <!-- 删除 -->
                            <div class="td_del">
                                <div class="item_del" @click="del(item)"><a href="javascript:void(0);"><i
                                            class="icon-new_trash" style="color: #6E7C7C;"></i></a></div>
                            </div>
                        </div>
                        <!-- 子商品模态框 -->
                        <div class="modal fade child" :id="'c' + item.item_id" tabindex="-1"
                            aria-labelledby="exampleModalLabel2" aria-hidden="true">
                            <div class="modal-dialog">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h1 class="modal-title fs-5" id="exampleModalLabel">{{ item.form_name }} </h1>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close"></button>
                                    </div>
                                    <div class="modal-body">
                                        <!-- {{ child_list }} -->
                                        <h2 class="title">请选择{{ child_num }}件商品 </h2>
                                        <div v-for="item, index in child_list">
                                            <div class="form_name"> *{{ item.form_name }}</div>
                                            <div class="number">
                                                <button type="button" class="btn iconfont" @click="decrement(index)">-
                                                </button>
                                                <input type="number" name="quantity" @input="validateInput(index)"
                                                    v-model="item.display_num" class=" text-center w-100   p-0"
                                                    data-max="1" data-min="1">
                                                <button type="button" class="btn iconfont" @click="increment(index)">+
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="modal-footer">
                                        <!-- <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> -->
                                        <button type="button" class="btn btn-primary"
                                            @click="opmodef(false)">確認</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="item_discount">

                        <!-- 小计 -->
                        <div class="item_last_subtotal item_row">
                            <div class="item_desc">
                                <p class="mb-0">小計</p>
                            </div>
                            <b class="item_money">${{ subtotal | formatNumberToqff }}</b>
                        </div>
                        <!-- 运费 -->
                        <div class="item_shipment item_row">
                            <div class="item_desc">
                                <label for="freight_detail" class="freight_detail_lab js_freight_list mb-0"
                                    title="運費詳情">
                                    <span>運費</span>
                                    <div class="shipment_upper">滿 $ {{ cart_list.shipment_upper_money }} 元免運費</div>
                                </label>

                            </div>
                            <b class="item_money">
                                {{ freight.price }}
                            </b>
                        </div>
                    </div>
                    <footer class="item_footer">
                        <div class="item_total item_row" style="background-color: #6E7C7C;">
                            <div class="item_desc">
                                <span class="item_total_title">總金額</span>
                                <span class="item_currency">(TWD)</span>
                            </div>
                            <div class="item_money">
                                <b class="item_total_inner">
                                    ${{ cart_list.total }}
                                </b>
                            </div>
                        </div>
                    </footer>

                </section>
            </div>
            <div class="goto_bill">
                <button @click="scrollToDiv()">
                    商品無誤，開始填寫資料
                    <i class="icon-keyboard_arrow_down" style="color: #fff; font-size: 24px; position: absolute;"></i>
                </button>
            </div>
            <div class="material" id="targetDiv">
                <ValidationObserver v-slot="{ handleSubmit }" ref="observer">
                    <form @submit.prevent="handleSubmit(goorder)">
                        <div class="item_area filed_area">
                            <div class="row">
                                <div class="information col-md-4">
                                    <header class="title_area clearfix">
                                        <hgroup class="title_content clearfix">
                                            <h4 class="main_title">購買資訊</h4>
                                        </hgroup>
                                        <hr class="main_hr">
                                    </header>


                                    <!-- 配送方式 -->
                                    <div class="form_group" id="shipping_area" v-if="logistics_number !== 0">
                                        <label for=""
                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">配送方式：</label>
                                        <div class="form_data" style="padding-bottom: 10px;">
                                            <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                <div class="control" :class="classes">
                                                    <select id="is_shop" class="form_select"
                                                        @change="selsetlogistics($event)" v-model="logistics_obj">
                                                        <!-- <option value="none" selected="" disabled>- 請選擇 配送方式 -</option> -->
                                                        <option :value="home_delivery">{{ home_delivery.name }}</option>
                                                        <option v-for="item in logistics.cvs" :value="item">{{
            item.name
        }}
                                                        </option>
                                                        <!-- :disabled="item.pay_mode === 'ReceivedPay711' && subtotal > 20000" -->
                                                    </select>
                                                    <span>{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <!-- 收件地址 -->
                                    <!-- :class="way ? '' : 'd-none'" -->
                                    <div class="form_group" id="address_outer_area">
                                        <label for=""
                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">填寫位址：</label>
                                        <div class="postbutton" :class="is_shop ? '' : 'd-none'"
                                            style="padding-bottom: 10px;">
                                            <form name="shop" method="post" :action=postUrl
                                                style="width: 50%; margin-right: 10px;">
                                                <input name="ReturnUrl" type="hidden" v-model="ReturnUrl">
                                                <input name="CustomerID" type="hidden" v-model="CustomerID">
                                                <button type="submit" @click="save_height">選擇位址</button>
                                            </form>
                                            <div class="form_group" id="address_area">
                                                <div class="form_data">
                                                    <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                        <div class="control" :class="classes">
                                                            <input id="address" :disabled=is_shop type="text"
                                                                v-model="order_address" class="form_input form_control"
                                                                placeholder="收件位址" value=""
                                                                data-gtm-form-interact-field-id="6"
                                                                @blur="insert($event)">
                                                            <span>{{ errors[0] }}</span>
                                                        </div>
                                                    </ValidationProvider>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- v-if="order_address !== ''" -->
                                        <div class="form_group" id="address_area" :class="is_shop ? 'd-none' : ''"
                                            style="padding-bottom: 10px;">
                                            <div class="form_data">
                                                <ValidationProvider rules="required" v-slot="{ errors, classes }">
                                                    <div class="control" :class="classes">
                                                        <input id="address" :disabled=is_shop type="text"
                                                            v-model="order_address" class="form_input form_control"
                                                            placeholder="收件位址" value=""
                                                            data-gtm-form-interact-field-id="6" @blur="insert($event)">
                                                        <span>{{ errors[0] }}</span>
                                                    </div>
                                                </ValidationProvider>
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 付款方式 -->
                                    <div class="form_group" id="shipping_area">
                                        <label for=""
                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">付款方式：</label>
                                        <div class="form_data">
                                            <select id="is_shop" class="form_select" @change="selsetpay($event)"
                                                v-model="payment_method_obj">
                                                <option value="none" selected="" disabled>‐ 請選擇 付款方式 ‐</option>
                                                <option v-for="item in payment_method" :value="item">{{
            item.alias
        }}
                                                </option>
                                                <!-- :disabled="item.pay_mode === 'ReceivedPay711' && subtotal > 20000" -->
                                            </select>
                                        </div>
                                    </div>
                                    <!-- 运费 -->

                                </div>
                                <div class="materials col-md-8">
                                    <div class="row">
                                        <div class="one col-md-6">
                                            <div class="clearfix">
                                                <header class="title_area clearfix">
                                                    <hgroup class="title_content clearfix">
                                                        <h4 class="main_title">購買人資料</h4>
                                                    </hgroup>
                                                    <hr class="main_hr">
                                                </header>
                                                <div class="row">
                                                    <div class="col-sm-12">
                                                        <label for=""
                                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">姓名：</label>
                                                        <div class="form_group" id="purchaser_name_area">
                                                            <div class="form_data">
                                                                <ValidationProvider rules="required"
                                                                    v-slot="{ errors, classes }">
                                                                    <div class="control" :class="classes">
                                                                        <input id="purchaser_name"
                                                                            class="form_input form_control"
                                                                            maxlength="30" placeholder="請輸入購買人姓名"
                                                                            type="text" v-model="order_name"
                                                                            @blur="insert($event)">
                                                                        <span>{{ errors[0] }}</span>
                                                                    </div>
                                                                </ValidationProvider>
                                                                <!-- <span class="msg_error"><i class="icon-new_exclamation"></i></span> -->
                                                            </div>
                                                            <!-- <div class="help_block"><i
                                                                                        class="icon-new_exclaim_circle"></i><span>姓名欄位只能輸入中文和英文。</span>
                                                                                </div> -->
                                                            <div class="help_block help_tips"><i
                                                                    class="icon-triangle-right"></i><span>務必正確輸入購買人姓名確保正確送達。</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-sm-12">
                                                        <label for=""
                                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">電話：</label>
                                                        <div class="form_group" id="purchaser_phone_area">
                                                            <div class="form_data">
                                                                <ValidationProvider rules="required"
                                                                    v-slot="{ errors, classes }">
                                                                    <div class="control" :class="classes">
                                                                        <input id="purchaser_phone"
                                                                            class="form_input form_control"
                                                                            placeholder="請輸入聯絡電話" type="tel"
                                                                            v-model="order_phone"
                                                                            @blur="insert($event)">
                                                                        <span>{{ errors[0] }}</span>
                                                                    </div>
                                                                </ValidationProvider>
                                                                <!-- <span class="msg_error"><i class="icon-new_exclamation"></i></span> -->
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- 电子邮件 -->

                                                <div class="form_group cleafix" style="margin-top: 10px;">
                                                    <div class="form_data">
                                                        <label for=""
                                                            style="margin-bottom: 5px;font-size: 14px;color: gray;">備註：</label>
                                                        <textarea class="form_textarea form_control"
                                                            placeholder="請輸入客戶備註(選填)" id="customer_text" cols="30"
                                                            rows="3" v-model="order_remark"></textarea>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                        <div class="two col-md-6">
                                            <header class="title_area clearfix">
                                                <hgroup class="title_content clearfix">
                                                    <h4 class="main_title">發票資料</h4>
                                                </hgroup>
                                                <hr class="main_hr">
                                            </header>
                                            <div class="invoice_area clearfix" id="js_invoice_area">
                                                <div class="row">
                                                    <div class="col-lg-12">
                                                        <div class="form_group">
                                                            <div class="form_data">
                                                                <div class="form_select_block">
                                                                    <select class="form_select"
                                                                        @change="select_invoice($event)"
                                                                        id="orders_invoice">
                                                                        <option value="null" disabled="">‐ 請選擇 發票資料 ‐
                                                                        </option>
                                                                        <option value="1">愛心捐贈</option>
                                                                        <option value="2">寄送至郵箱</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form_group" id="carrier_type_area"
                                                            :class="bill == 2 ? '' : 'd-none'"
                                                            style="margin-top: 10px;">
                                                            <div style="font-size: 14px;">
                                                                <label for=""
                                                                    style="margin-bottom: 5px;color: gray;">受買人名字：</label>
                                                                <ValidationProvider
                                                                    :rules="bill == 1 ? '' : 'required|'"
                                                                    v-slot="{ errors, classes }">
                                                                    <div class="control" :class="classes">
                                                                        <input type="text" name="" id=""
                                                                            v-model="company">
                                                                        <span>{{ errors[0] }}</span>
                                                                    </div>
                                                                </ValidationProvider>
                                                            </div>
                                                            <div style="margin-top: 10px; font-size: 14px;">
                                                                <label for=""
                                                                    style="margin-bottom: 5px;color: gray;">統一編號（選填）：</label>
                                                                <input type="text" name="" id="" v-model="identifier">
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                                <div class="form_group form_success" id="purchaser_email_area"
                                                    style="margin-top: 10px;">
                                                    <label v-if="bill == 1" for=""
                                                        style="margin-bottom: 5px;color: gray; font-size: 14px;">郵箱（選填）：</label>
                                                    <label v-else for=""
                                                        style="margin-bottom: 5px;color: gray; font-size: 14px;">郵箱（必填）：</label>
                                                    <div class="form_data">
                                                        <ValidationProvider
                                                            :rules="bill == 1 ? 'email' : 'required|email'"
                                                            v-slot="{ errors, classes }">
                                                            <div class="control" :class="classes">
                                                                <input id="purchaser_email"
                                                                    class="form_input form_control"
                                                                    placeholder="ex: example@gmail.com" type="email"
                                                                    v-model="order_email" value=""
                                                                    data-gtm-form-interact-field-id="8"
                                                                    @blur="insert($event)">
                                                                <span>{{ errors[0] }}</span>
                                                            </div>
                                                        </ValidationProvider>
                                                    </div>
                                                    <div class="help_block help_tips"><i
                                                            class="icon-new_check_circle"></i><span>我們會將您的訂單通知信寄送至此。</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="bottom_total_area active clearfix">
                                <div class="form_group after_total_block">

                                    <label class="after_total_inner mb-0">
                                        <div class="after_total_title">實付金額(TWD)</div>
                                        <div class="after_total_pay"><span class="js_total">${{ cart_list.total
                                                }}</span>
                                            <!-- <label for="after_total"
                                                            class="after_total_lab mb-0" title="訂單詳情"><i class="icon-new_order"></i></label> -->
                                        </div>
                                    </label>
                                </div>
                                <div class="form_group mb-0">
                                    <div class="row">
                                        <div class="col-lg-2 offset-lg-10 col-md-3 offset-md-9 col-sm-3 offset-sm-9">

                                            <button id="order_submit" :disabled="disbutton"
                                                class="btn el_btn md solid el_rounded el_text m-0 w-100 js_hover_effect"
                                                style="background-color: #F17C67;border-color:#F17C67;color: #ffffff;">
                                                下一步
                                            </button>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </form>
                </ValidationObserver>
            </div>
        </div>
        <div v-else>
            <div
                style="font-size: 100px; color: #d9d9d9; display: flex;flex-direction: column;align-items: center; padding: 10px;">
                <i class="icon-new_nocart"></i>
                <span style="font-size: 28px;">購物車內無任何商品！</span>
            </div>
        </div>


    </div>
</template>

<script>
import Vue from 'vue'

import { mapState } from 'vuex'
import Swal from 'sweetalert2/dist/sweetalert2.all.js'
import numeral from "numeral";
// import $ from 'jquery'
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import FacebookEventApi from '@/js/FacebookEventApi'
export default {
    components: {
        ValidationProvider,
        ValidationObserver
    },
    filters: {
        formatNumberToqff(val) {
            return numeral(val).format('0,0');
        }
    },
    // components: { VDistpicker },
    data() {
        return {
            select: {
                city: '',
                area: '',
            },
            // 运输方式
            disbutton: false,
            way: false,
            pay: false,

            vehicles: 1,
            ipnum: '1',
            subtotal: 0,
            // 用户
            order_name: '',
            order_address: '',
            order_phone: '',
            order_email: '',
            order_remark: '',

            // 发票资料选了寄至邮箱的
            company: '',
            identifier: '',
            bill: '1',
            type: '1',
            payment_type: '',
            payment_method_obj: 'none',
            is_ReceivedPay: false,
            //选择超商
            logistics_obj: {
                enable: 'Y',
                // id: '',
                lkey: 'home_delivery',
                name: '宅配',
            },
            //宅配
            home_delivery: {
                enable: 'Y',
                // id: '',
                lkey: 'home_delivery',
                name: '宅配',
            },
            // 是否到店取货
            is_shop: false,
            // 当前地址
            postUrl: '',
            ReturnUrl: '',
            CustomerID: '8290209801',
            //Purchase
            content_ids: [],//预计是数组 各个商品的item+id
            content_name: 'V1_PURCHASE',
            contents: [],//预计是数组，个个商品的id
            num_items: '',//购物车的有多少件不同的商品数量
            // value:'',//购物车费用的总计
            // phone:'',//电话
            // ph:'',//电话
            //child
            child_list: [],//子商品内容
            child_num: '',//子商品默认数量
            child_number: '',//记录商品数量总和
            parm: [],//修改后的子商品各个的数量
            selectname: '',//商品id

            //赠品
            free: [],//赠品
            free_num: '',//赠品数量
            free_number: '',//记录赠品数量总和
            free_parm: [],//修改后的赠品各个的数量

        };
    },
    computed: {
        ...mapState('header', ['cate', 'getfb', 'ads']),
        ...mapState('order', ['payment_method', 'logistics', 'logistics_number']),
        ...mapState('cart', ['number', 'cart_list_item', 'freight', 'cart_list']),
        totalSum() {
            return this.child_list.reduce((sum, item) => sum + item.display_num, 0);
        }
    },
    watch: {},
    methods: {
        opmodef(val) {
            // this.item=this.$store.getters["commodity/details"];
            // this.clickvalue();
            let numbers = 0
            if (val) {
                this.parm = this.child_list.map(item => {
                    numbers += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num * this.child_number
                    };
                });
            } else {
                this.parm = this.child_list.map(item => {
                    numbers += item.display_num
                    return {
                        item: item.isubid,
                        num: item.display_num
                    };
                });
            }
            this.free_parm = this.free.map(item => {
                // number_free += item.display_num
                return {
                    item: item.isubid,
                    num: this.free_num * this.child_number
                };
            });
            this.parm = this.parm.concat(this.free_parm);
            this.free_parm = [];
            if (numbers == this.child_num) {
                this.$store.dispatch('cart/add', {
                    action: 'UPDATE',
                    itemid: this.selectname,
                    number: this.child_number,
                    type: 'NOR',
                    param: this.parm,
                }).then((e) => {
                    const Toast = Swal.mixin({
                        toast: true,
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 1500,
                        didOpen: (toast) => {
                            toast.addEventListener('mouseenter', Swal.stopTimer)
                            toast.addEventListener('mouseleave', Swal.resumeTimer)
                        }
                    })
                    if (e.result) {
                        Toast.fire({
                            icon: 'success',
                            title: '成功加入購物車'
                        })
                        this.subtotal = 0
                        this.ipnum = this.$store.getters['cart/cart_list_item'];
                        this.ipnum.forEach(element => {
                            this.subtotal += element.price.replace(/,/g, "") * element.num;
                        });
                    } else {
                        Toast.fire({
                            icon: 'error',
                            title: `${e.message}`
                        })
                    }

                });
                if (!val) {
                    const myModal = this.$bootstrap.Modal.getInstance(document.getElementById('c' + this.selectname));
                    myModal.hide();
                }
            } else {
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'warning',
                    title: `數量選擇有錯哦! 您可以選 ${this.child_num} 樣商品^_^`
                })
            }
        },
        // setCity({ city, area }) {
        //     // console.log(this.select);
        //     if (this.select.area == '区' && this.area == true) {
        //         // console.log(1);
        //         $('.form-city').addClass('error');
        //     } else {
        //         // this.area=false;

        //         $('.form-city').removeClass('error');
        //     }

        //     this.select.city = city.value
        //     this.select.area = area.value
        //     // console.log(city.value);
        //     // console.log(area.value);
        // },
        selsetpay(e) {
            // console.log(this.payment_method_obj, 'this付款方式');
            // console.log(e, 'e付款方式');
            sessionStorage.setItem("pay_mode", JSON.stringify(this.payment_method_obj));
            // if (this.payment_method_obj.name === 'Ezcat') {

            //     this.is_ReceivedPay = true;
            // } else {
            //     this.is_ReceivedPay = false;
            //     this.is_shop = false;
            //     this.order_address='';
            //     this.logistics_obj='none'

            // }
            this.payment_type = this.payment_method_obj.pay_mode;
            this.$store.dispatch('user/save', {
                address: this.order_address,
                name: this.order_name,
                phone: this.order_phone
            })

        },
        selsetlogistics(e) {
            // console.log(this.logistics_obj, 'this超商方式');
            // console.log(e, 'e超商方式');
            if (this.logistics_obj.lkey === 'SudaB2S') {
                this.order_address = '';
                if (sessionStorage.getItem("addressData") != null) {
                    //自定义代码
                    const addressDataJSON = sessionStorage.getItem("addressData");
                    const addressData = JSON.parse(addressDataJSON);
                    this.order_address = addressData.storeid + '|' + addressData.storename + '|' + addressData.storeaddress;
                }
                this.is_shop = true;
            } else {
                this.is_shop = false;
                this.order_address = '';
            }
            sessionStorage.setItem("logistics", JSON.stringify(this.logistics_obj));
        },
        changevehicles(e) {
            // switch (e.target.value) {
            //     case '1':
            //         this.vehicles = e.target.value
            //         break;
            //     case '2':
            //         this.vehicles = e.target.value
            //         break;
            //     case '3':
            //         this.vehicles = e.target.value
            //         break;
            //     case '4':
            //         this.vehicles = e.target.value
            //         break;
            //     default:
            //         this.vehicles = e.target.value
            //         break;
            // }
        },
        select_invoice(e) {
            switch (e.target.value) {
                case '1':
                    this.bill = '1';
                    this.company = '';
                    break;

                case '2':
                    this.bill = '2';
                    let buyname = this.order_name;
                    this.company = buyname;
                    break;
                default:
                    this.bill = 0
                    break;
            }
        },
        callback() {
            console.log('callback FB');
        },
        goorder() {
            this.cart_list.item.forEach(element => {
                console.log(element);
                this.content_ids.push('item' + element.item_id);
                this.contents.push({ 'id': element.item_id, 'quantity': element.num })
            });
            if (this.payment_type !== '' && this.payment_type !== 'none') {
                this.disbutton = true;
                var x = this.cart_list.total;
                var cartTotal = x.replace(/[^0-9.]/g, "");
                var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
                var fb_em = myFacebookEventApi.fbgetCookie('em');
                var fb_phone = myFacebookEventApi.fbgetCookie('phone');
                var fb_fn = myFacebookEventApi.fbgetCookie('fn');
                var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
                var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
                myFacebookEventApi.callPurchase2(this.callback(), this.content_ids, this.content_name, this.cart_list.item.length, this.contents, cartTotal, fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
                var note = this.order_remark.replace(/\n/g, " ");
                this.$store.dispatch('order/post',
                    {
                        note: note,
                        address: this.order_address,
                        email: this.order_email,
                        name: this.order_name,
                        phone: this.order_phone,
                    }).then(() => {
                        this.$store.dispatch('cart/get').then(() => {

                        });                        
                        this.$store.dispatch('order/selectinvoice', {
                            order_number: this.$store.getters['order/submitorder'],
                            company:this.company,
                            email: this.order_email,
                            identifier: this.identifier,
                            type: this.bill
                        }).then(() => {
                            //付款
                            this.$store.dispatch('order/payment', {
                                order_num: this.$store.getters['order/submitorder'],
                                type: this.payment_type
                            }).then(() => {
                                this.disbutton = false;
                                if (this.ads && this.ads.buy !== "") {
                                    gtag('event', 'conversion', {
                                        'send_to': this.ads.buy,
                                        'value': this.cart_list.total,
                                        'currency': 'TWD',
                                        'transaction_id': ''
                                    });
                                }
                                this.$store.dispatch('order/logsucc_order');
                                sessionStorage.removeItem('addressData');
                                sessionStorage.removeItem('logistics');
                                sessionStorage.removeItem('pay_mode');
                                this.$router.push({
                                    path: `/order/${this.$store.getters['order/submitorder']}`
                                }).catch(err => { })
                            });
                        });
                    });
            } else {
                this.disbutton = false;
                const Toast = Swal.mixin({
                    toast: true,
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 1500,
                    // timerProgressBar: true,
                    didOpen: (toast) => {
                        toast.addEventListener('mouseenter', Swal.stopTimer)
                        toast.addEventListener('mouseleave', Swal.resumeTimer)
                    }
                })

                Toast.fire({
                    icon: 'error',
                    title: '請選擇付款方式'
                })
            }

        },
        // 数量减
        reduce(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            // console.log(e);
            if (num > 1) {
                num = --e.num;
                this.child_number = num;
                this.parm = []
                if (e.sub.length !== 0) {
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num * this.child_number || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            this.free_parm = this.free.map(item => {
                                return {
                                    item: item.isubid,
                                    num: this.free_num * num
                                };
                            });
                            if (response.data.sub.length === 1) {
                                this.child_num = response.data.num || 0;
                                this.child_list[0].display_num = response.data.num
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                this.opmodef(true);
                            } else
                                if (response.data.num !== 0) {
                                    const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.selectname));
                                    myModal.show();
                                }
                                else if (response.data.sub.length === 0) {
                                    this.opmodef(true);
                                }
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'error',
                                title: `${response.message}`
                            })
                        }
                        // $('#myModal').modal('show');
                        // console.log($('#myModal'));
                        // console.log($('#myModal').modal());
                    });
                } else {
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                        this.subtotal = 0
                        this.ipnum = this.$store.getters['cart/cart_list_item'];
                        this.ipnum.forEach(element => {
                            this.subtotal += element.price.replace(/,/g, "") * element.num;
                        });
                    });
                }
                // this.ipnum[index].num--;
                // let number = this.ipnum[index].num;
                // this.$store.dispatch("cart/update", {
                //     itemid: e.item_id,
                //     number: num,
                // }).then(() => {
                //     this.subtotal = 0
                //     this.ipnum = this.$store.getters['cart/cart_list_item'];
                //     this.ipnum.forEach(element => {
                //         this.subtotal += element.price.replace(/,/g, "") * element.num;
                //     });
                // });
            }
            // this.num[index]--;
            // console.log(e,this.num[index]);
        },
        // 数量加
        add(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            if (num < 99) {
                num = ++e.num;
                this.child_number = num;
                this.parm = []
                if (e.sub.length !== 0) {
                    this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                        if (response.result) {
                            this.child_list = response.data.sub || [];
                            this.child_num = response.data.num * this.child_number || 0;
                            this.free = response.data.sub_free || [];
                            this.free_num = response.data.num_free || 0;
                            this.free_parm = this.free.map(item => {
                                return {
                                    item: item.isubid,
                                    num: this.free_num * num
                                };
                            });
                            if (response.data.sub.length === 1) {
                                this.child_num = response.data.num || 0;
                                this.child_list[0].display_num = response.data.num
                                this.parm = [
                                    {
                                        item: response.data.sub[0].isubid,
                                        num: response.data.num
                                    }
                                ]
                                this.opmodef(true);
                            } else
                                if (response.data.num !== 0) {
                                    const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.selectname));
                                    myModal.show();
                                }
                                else if (response.data.sub.length === 0) {
                                    this.opmodef(true);
                                }
                        } else {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })

                            Toast.fire({
                                icon: 'error',
                                title: `${response.message}`
                            })
                        }
                        // $('#myModal').modal('show');
                        // console.log($('#myModal'));
                        // console.log($('#myModal').modal());
                    });
                } else {
                    this.$store.dispatch("cart/update", {
                        itemid: e.item_id,
                        number: num,
                    }).then(() => {
                        this.subtotal = 0
                        this.ipnum = this.$store.getters['cart/cart_list_item'];
                        this.ipnum.forEach(element => {
                            this.subtotal += element.price.replace(/,/g, "") * element.num;
                        });
                    });
                }
                // this.$store.dispatch("cart/update", {
                //     itemid: e.item_id,
                //     number: num,
                // }).then(() => {
                //     this.subtotal = 0
                //     this.ipnum = this.$store.getters['cart/cart_list_item'];
                //     this.ipnum.forEach(element => {
                //         this.subtotal += element.price.replace(/,/g, "") * element.num;
                //     });
                // });
            }
        },
        changebalue(e, index) {
            this.selectname = e.item_id;
            let num = e.num;
            num = e.num * 1;
            this.child_number = num;
            if (e.sub.length !== 0) {
                this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                    if (response.result) {
                        this.child_list = response.data.sub || [];
                        this.child_num = response.data.num * this.child_number || 0;
                        this.free = response.data.sub_free || [];
                        this.free_num = response.data.num_free || 0;
                        this.free_parm = this.free.map(item => {
                            return {
                                item: item.isubid,
                                num: this.free_num * num
                            };
                        });
                        if (response.data.sub.length === 1) {
                            this.child_num = response.data.num || 0;
                            this.child_list[0].display_num = response.data.num
                            this.parm = [
                                {
                                    item: response.data.sub[0].isubid,
                                    num: response.data.num
                                }
                            ]
                            this.opmodef(true);
                        } else
                            if (response.data.num !== 0) {
                                const myModal = new this.$bootstrap.Modal(document.getElementById('c' + this.selectname));
                                myModal.show();
                            }
                            else if (response.data.sub.length === 0) {
                                this.opmodef(true);
                            }
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })

                        Toast.fire({
                            icon: 'error',
                            title: `${response.message}`
                        })
                    }
                })
            } else {
                this.$store.dispatch("cart/update", {
                    itemid: e.item_id,
                    number: num,
                });
            }
        },
        // 删除商品
        del(e) {
            if (e.sub.length !== 0) {
                this.$store.dispatch('commodity/getsubcategory', e.item_id).then(response => {
                    if (response.result) {
                        // if (response.data.num !== 0) {
                        this.child_list = response.data.sub || [];
                        this.child_num = response.data.num || 0;
                        this.free = response.data.sub_free || [];
                        this.free_num = response.data.num_free || 0;

                        this.parm = this.child_list.map(item => {
                            return {
                                item: item.isubid,
                                num: 0
                            };
                        });
                        this.free_parm = this.free.map(item => {
                            return {
                                item: item.isubid,
                                num: 0
                            };
                        });
                        this.parm = this.parm.concat(this.free_parm);
                        this.free_parm = [];
                        this.$store.dispatch('cart/add', {
                            action: 'UPDATE',
                            itemid: e.item_id,
                            number: 0,
                            type: 'NOR',
                            param: this.parm,
                        }).then((e) => {
                            const Toast = Swal.mixin({
                                toast: true,
                                position: 'top-end',
                                showConfirmButton: false,
                                timer: 1500,
                                didOpen: (toast) => {
                                    toast.addEventListener('mouseenter', Swal.stopTimer)
                                    toast.addEventListener('mouseleave', Swal.resumeTimer)
                                }
                            })
                            if (e.result) {
                                Toast.fire({
                                    icon: 'success',
                                    title: '成功删除'
                                })
                                this.subtotal = 0
                                this.ipnum = this.$store.getters['cart/cart_list_item'];
                                this.ipnum.forEach(element => {
                                    this.subtotal += element.price.replace(/,/g, "") * element.num;
                                });
                            } else {
                                Toast.fire({
                                    icon: 'error',
                                    title: `${e.message}`
                                })
                            }

                        });
                        // }
                    } else {
                        const Toast = Swal.mixin({
                            toast: true,
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 1500,
                            didOpen: (toast) => {
                                toast.addEventListener('mouseenter', Swal.stopTimer)
                                toast.addEventListener('mouseleave', Swal.resumeTimer)
                            }
                        })

                        Toast.fire({
                            icon: 'error',
                            title: `${response.message}`
                        })
                    }
                    // $('#myModal').modal('show');
                    // console.log($('#myModal'));
                    // console.log($('#myModal').modal());
                });
            } else {
                this.$store.dispatch("cart/del", {
                    itemid: e.item_id,
                }).then(() => {
                    this.subtotal = 0
                    this.ipnum = this.$store.getters['cart/cart_list_item'];
                    this.ipnum.forEach(element => {
                        this.subtotal += element.price.replace(/,/g, "") * element.num;
                    });
                });
            }
        },
        insert(e) {
            // this.$refs.observer.validate();
            // console.log(1);
            if (this.order_name) {
                document.cookie = "fn=" + this.order_name + ";path=/;max-age=172800"; // Cookie 保存一天
            }
            if (this.order_email) {
                document.cookie = "em=" + this.order_email + ";path=/;max-age=172800"; // Cookie 保存一天
            }
            if (this.order_phone) {
                document.cookie = "external_id=" + this.order_phone + ";path=/;max-age=172800"; // Cookie 保存一天
                document.cookie = "phone=" + this.order_phone + ";path=/;max-age=172800"; // Cookie 保存一天
            }
            this.$store.dispatch('user/save', {
                address: this.order_address,
                name: this.order_name,
                phone: this.order_phone
            })
        },
        //滑下去结账
        scrollToDiv() {
            const targetDiv = document.getElementById("targetDiv");
            targetDiv.scrollIntoView({ behavior: "smooth" });
        },
        // 保存滑下去的状态
        save_height() {
            sessionStorage.setItem("save_height", 'save_height');
        },
        increment(index) {
            if (this.totalSum < this.child_num) {
                this.child_list[index].display_num++;
            }
        },
        validateInput(index) {
            // 确保当前输入是一个有效数字
            this.child_list[index].display_num = Math.max(0, parseInt(this.child_list[index].display_num) || 0);

            // 计算所有 display_num 的总和
            let total = this.child_list.reduce((sum, item) => sum + item.display_num, 0);

            // 如果总和超过 child_num，则减少当前输入的值
            if (total > this.child_num) {
                let excess = total - this.child_num;
                this.child_list[index].display_num = Math.max(0, this.child_list[index].display_num - excess);
            }
        },
        decrement(index) {
            if (this.child_list[index].display_num > 0) {
                this.child_list[index].display_num--;
            }
        },
    },
    created() {
    },
    mounted() {

        if (typeof window !== 'undefined') {
            const VueNoty = require('vuejs-noty')
            Vue.use(VueNoty)
            require('vuejs-noty/dist/vuejs-noty.css')
        }

        this.$store.dispatch('user/get').then(() => {
            this.order_name = this.$store.getters['user/name'];
            this.order_phone = this.$store.getters['user/phone'];
            this.order_address = this.$store.getters['user/address'];
            // console.log(this.name);
            // 保存地址
            if (sessionStorage.getItem("addressData") != null) {
                //自定义代码
                const addressDataJSON = sessionStorage.getItem("addressData");
                // const select_name = sessionStorage.getItem("pay_mode");
                const select_logistics = sessionStorage.getItem("logistics");
                const addressData = JSON.parse(addressDataJSON);
                if (JSON.parse(select_logistics).lkey === 'SudaB2S') {
                    // console.log(1);
                    this.order_address = addressData.storeid + '|' + addressData.storename + '|' + addressData.storeaddress;
                } else {
                    // console.log(2);
                    this.order_address = ''
                }
            }


            if (sessionStorage.getItem("save_height") != null) {
                this.scrollToDiv();
                sessionStorage.removeItem('save_height');
            }
        })

        this.ReturnUrl = window.location.href;
        if (window.innerWidth > 600) {
            this.postUrl = 'https://appservice.ezcat.com.tw/Map.aspx'
        } else {
            this.postUrl = 'https://appservice.ezcat.com.tw/MobileMap.aspx'

        }

        // console.log('前面');
        this.$store.dispatch('cart/get').then(() => {
            if (this.$store.getters['cart/number'] != 0) {
                this.ipnum = this.$store.getters['cart/cart_list_item'];
                this.ipnum.forEach(element => {
                    this.subtotal += element.price.replace(/,/g, "") * element.num
                });
                // console.log(this.subtotal>20000);
            }
        })
        // console.log(this.$store.getters['cart/number']);
        // 保存选择是否店取
        this.$store.dispatch('order/get').then(e => {
            if (sessionStorage.getItem("pay_mode") != null) {
                // const selectElement = document.getElementById("is_shop");
                // selectElement.value = sessionStorage.getItem("pay_mode");
                const select_name = sessionStorage.getItem("pay_mode");
                this.payment_method_obj = JSON.parse(select_name);
                this.payment_type = JSON.parse(select_name).pay_mode;
                // if (JSON.parse(select_name).name === 'Ezcat') {
                //     this.is_ReceivedPay = true;
                //     // this.is_shop = true;
                // } else {
                //     this.is_ReceivedPay = false;
                //     // this.is_shop = false;
                // }
            }
            if (sessionStorage.getItem("logistics") != null) {
                const select_logistics = sessionStorage.getItem("logistics");
                this.logistics_obj = JSON.parse(select_logistics);
                if (JSON.parse(select_logistics).lkey === 'SudaB2S') {
                    this.is_shop = true;
                } else {
                    this.is_shop = false;
                }
            } else {
                sessionStorage.setItem("logistics", JSON.stringify(this.logistics_obj));
            }
        });
        this.$store.dispatch('order/get_logistics').then(e => {
            // console.log(e, 'e');
            // console.log(this.logistics.cvs.length, 'this');
        });




    },
}
</script>

<style lang='scss' scoped src="./index.scss"></style>

<style lang="scss" scoped>
.control {
    width: 100%;

    span {
        display: block;
        font-size: 12px;
    }

    input {
        padding: 5px 10px;
    }

    &.failed {
        input {
            border: 1px #eb0600 solid !important;
        }

        select {

            border: 1px #eb0600 solid !important;
        }
    }

}

.control.failed input,
.control.failed span {
    color: #eb0600;
}

.postbutton {
    display: flex;
    // margin-top: 10px;
    // flex-direction: column;
    flex-direction: row;
    // align-items: center;

    button {
        width: 100%;
        padding: 8px 10px;
        border: none;
        // margin: 10px;
    }
}


.child {

    h2 {
        margin: 0 0 16px;
    }

    .form_name {
        color: black;
        font-size: 16px;
    }

    .number {
        margin-bottom: 16px;
        display: flex;
        justify-content: space-between;
        height: 40px;

        input {
            width: 100%;
            height: 40px;
            text-align: center;
            // max-height: 36px;
            outline-style: none;
            border: 1px solid #e2e2e2;
            border-left: none;
            border-right: none;

            &:focus {}
        }

        button {
            background-color: #fff;
            color: #BBB19E;
            height: 40px;
            line-height: 1.5px;
            padding: 6px 12px;
            border: 1px solid #e2e2e2;
            border-radius: 5px;
            cursor: pointer;

            &:not(:first-child) {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                font-size: 30px;
                // line-height: 1;
            }

            &:first-child {
                font-size: 38px;

                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }
        }

        input::-webkit-outer-spin-button,
        input::-webkit-inner-spin-button {
            -webkit-appearance: none;
            margin: 0;
        }

        /* 针对 Firefox */
        input[type=number] {
            -moz-appearance: textfield;
        }

        /* 针对 IE11 */
        input[type=number]::-ms-clear {
            display: none;
        }

    }

    .btn {
        text-align: center;

        button {
            height: 40px;
            width: 100px;
            /* 重置边框和背景样式 */
            border: none;
            background: none;
            /* 重置内外边距 */
            padding: 0;
            margin: 0;
            /* 设置字体样式 */
            font-family: inherit;
            font-size: inherit;
            /* 设置颜色 */
            color: inherit;
            /* 设置鼠标样式 */
            cursor: pointer;
            /* 去除按钮的外观 */
            appearance: none;
            /* 其他可能需要的样式 */
            /* outline: none; */
            /* 注意：如果使用 outline: none;，请提供其他焦点样式以保持可访问性 */
            /* 其他重置样式，根据需要添加 */
            background-color: #11ADD8;
            color: white;
            border-radius: 5px;
        }
    }




}
</style>